import Marquee from "react-fast-marquee";
import { useI18n } from "@/i18n/LanguageContext";

export default function EditorialMarquee() {
  const { t } = useI18n();

  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-pine/20 bg-pine py-6"
      aria-hidden="true"
    >
      <Marquee speed={32} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span className="font-serif text-2xl italic tracking-wide text-cream sm:text-3xl">
              {item}
            </span>
            <span className="text-copper">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
